import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * same as form, but accepts additional props
 * {
 *  validators: {formId: function(value) => {status: ok/fail/pending, msg: 'string'}}
 * }
 *
 * prevents submit if status = "invalid"" or "onSubmit" props presented;
 */

import React, { Children, Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { mapValues, mergeDeep, omit } from "./utils";
import { Form } from '.';
var SmartForm = /*#__PURE__*/function (_Component) {
  _inherits(SmartForm, _Component);
  var _super = _createSuper(SmartForm);
  function SmartForm(props) {
    var _this;
    _classCallCheck(this, SmartForm);
    _this = _super.call(this, props);
    // todo batch to one atomic operation
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value, id, child) {
      _this.setState({
        inputs: mergeDeep(_this.state.inputs, _defineProperty({}, id, {
          value: value
        }))
      }, _this.validate);
      if (child.props.onChange) {
        child.props.onChange(value, _this.state.inputs);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (id, child) {
      _this.setState({
        inputs: mergeDeep(_this.state.inputs, _defineProperty({}, id, {
          touched: false
        }))
      }, _this.validate);
      if (child.props.onFocus) {
        child.props.onFocus();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (id, child) {
      _this.setState({
        inputs: mergeDeep(_this.state.inputs, _defineProperty({}, id, {
          touched: true
        }))
      }, _this.validate);
      if (child.props.onBlur) {
        child.props.onBlur();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event) {
      event.stopPropagation();
      event.preventDefault();
      var inputs = _this.innerRefs;
      if (_this.state.status === 'valid') {
        if (_this.props.onSubmit) {
          _this.props.onSubmit(mapValues(inputs, function (input) {
            return input.getValue();
          }), event);
        } else {
          event.target.submit();
        }
      } else {
        var touchedInputs = mapValues(_this.state.inputs, function (input) {
          return _objectSpread(_objectSpread({}, input), {
            touched: true
          });
        });
        if (_this.props.onSubmitFailed) {
          _this.props.onSubmitFailed();
        }
        _this.setState({
          inputs: touchedInputs
        }, _this.validate);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "submitForm", function () {
      _this.props.onSubmit(mapValues(_this.innerRefs, function (input) {
        return input.getValue();
      }));
    });
    _this.state = {
      status: 'untouched',
      inputs: {}
    };
    _this.innerRefs = {};
    return _this;
  }
  _createClass(SmartForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        inputs: this.collectState()
      }, this.validate);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.children !== this.props.children) {
        this.setState({
          inputs: mergeDeep(this.state.inputs, this.collectState())
        }, this.validate);
      }
    }
  }, {
    key: "collectState",
    value: function collectState() {
      var _this2 = this;
      var states = {};
      Object.keys(this.innerRefs).forEach(function (key) {
        var ref = _this2.innerRefs[key];
        if (ref) {
          states[key] = {
            value: ref.getValue ? ref.getValue() : '',
            title: ref.props.title
          };
        }
      });
      return states;
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this3 = this;
      var inputs = this.state.inputs;
      var formStatus = 'valid';
      if (!this.props.validator) {
        this.setState({
          status: formStatus
        });
        return inputs;
      }
      var validatedInputs = mapValues(inputs, function (input, key) {
        var inputValidator = _this3.props.validator[key];
        if (inputValidator) {
          var validationResult = inputValidator(input.value);
          if (validationResult.status !== 'ok') {
            formStatus = 'invalid';
          }
          return _objectSpread(_objectSpread({}, input), validationResult);
        }
        return input;
      });
      this.setState({
        inputs: validatedInputs,
        status: formStatus
      });
      if (this.props.onValidate) {
        this.props.onValidate(validatedInputs);
      }
      return inputs;
    }
  }, {
    key: "mapChildren",
    value: function mapChildren(children) {
      var _this4 = this;
      var inputs = this.state.inputs;
      var inputsState = mergeDeep(inputs, this.props.serverErrors);
      this.innerRefs = {};
      return Children.map(children, function (child) {
        // todo: maybe find better variant
        if (!child || !child.props) return child;
        var id = child.props.inputId;
        if (id) {
          var inputInfo = inputsState[id] || {};
          var showError = inputInfo.forceError || inputInfo.touched || child.props.forceTouch;
          return /*#__PURE__*/cloneElement(child, {
            onChange: function onChange(value) {
              return _this4.handleChange(value, id, child);
            },
            onFocus: function onFocus() {
              return _this4.handleFocus(id, child);
            },
            onBlur: function onBlur() {
              return _this4.handleBlur(id, child);
            },
            status: showError ? inputInfo.status : null,
            msg: showError ? inputInfo.msg : null,
            forceError: inputInfo.forceError,
            ref: function ref(_ref) {
              _this4.innerRefs[id] = _ref;
            }
          });
        } else if (child.props.type === 'submit') {
          return _this4.props.disableIfInvalid ? /*#__PURE__*/cloneElement(child, {
            disabled: child.props.disabled || _this4.state.status !== 'valid'
          }) : child;
        } else if (child.props.isSmartFormHelper) {
          return /*#__PURE__*/cloneElement(child, {
            inputs: inputs
          });
        } else if (child.props.children) {
          return /*#__PURE__*/cloneElement(child, {}, _this4.mapChildren(child.props.children));
        }
        return child;
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Form, _extends({}, omit(this.props, ['validator', 'disableIfInvalid', 'serverErrors', 'onValidate']), {
        onSubmit: this.handleSubmit
      }), this.mapChildren(this.props.children));
    }
  }]);
  return SmartForm;
}(Component);
_defineProperty(SmartForm, "defaultProps", {
  serverErrors: {}
});
export { SmartForm as default };
SmartForm.propTypes = process.env.NODE_ENV !== "production" ? {
  validator: PropTypes.object,
  disableIfInvalid: PropTypes.bool,
  onSubmit: PropTypes.func,
  onValidate: PropTypes.func,
  serverErrors: PropTypes.object
} : {};